(function () {
  'use strict';

  function bootGallery(gallery) {
    if (!gallery || gallery.__profGalleryBooted) return;
    gallery.__profGalleryBooted = true;
    gallery.setAttribute('data-prof-gallery-ready', 'true');

    var product = gallery.closest('[data-professional-paint-product]') || document;
    var initialSlides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-figure]'));
    var current = Math.max(0, initialSlides.findIndex(function (slide) {
      return slide.getAttribute('data-gallery-selected') === 'true';
    }));
    var pointerStart = null;

    function getSlides() {
      return Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-figure]'));
    }

    function renderPreview(index) {
      var slides = getSlides();
      var preview = product.querySelector('[data-prof-gallery-preview]');
      var previewContent = preview && preview.querySelector('[data-prof-gallery-preview-content]');
      if (!preview || !previewContent || slides.length < 2) {
        if (preview) preview.hidden = true;
        return;
      }
      var sourceImage = slides[index] && slides[index].querySelector('img');
      if (!sourceImage) {
        preview.hidden = true;
        return;
      }
      var previewImage = document.createElement('img');
      previewImage.src = sourceImage.currentSrc || sourceImage.getAttribute('src');
      previewImage.alt = '';
      previewImage.loading = 'eager';
      previewImage.width = 4096;
      previewImage.height = 4096;
      previewImage.setAttribute('aria-hidden', 'true');
      previewContent.replaceChildren(previewImage);
      preview.hidden = false;
      preview.setAttribute('data-preview-index', String(index));
      preview.setAttribute('aria-label', 'View professional paint image ' + (index + 1) + ' of ' + slides.length);
    }

    function select(index) {
      var slides = getSlides();
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var selected = slideIndex === current;
        slide.setAttribute('data-gallery-selected', String(selected));
        slide.setAttribute('aria-hidden', String(!selected));
        slide.setAttribute('tabindex', selected ? '0' : '-1');
      });
      var count = gallery.querySelector('[data-prof-gallery-count]');
      if (count) count.textContent = (current + 1) + ' / ' + slides.length;
      renderPreview((current + 1) % slides.length);
    }

    gallery.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target : null;
      if (!target) return;
      if (target.closest('[data-prof-gallery-prev]')) {
        event.stopPropagation();
        select(current - 1);
      } else if (target.closest('[data-prof-gallery-next]')) {
        event.stopPropagation();
        select(current + 1);
      }
    });

    if (!product.__profPreviewDelegated) {
      product.__profPreviewDelegated = true;
      product.addEventListener('click', function (event) {
        var target = event.target && event.target.closest ? event.target.closest('[data-prof-gallery-preview]') : null;
        if (target) select(current + 1);
      });
    }

    gallery.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        select(current - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        select(current + 1);
      }
    });

    gallery.addEventListener('pointerdown', function (event) {
      if (event.target && event.target.closest('button')) return;
      pointerStart = { x: event.clientX, y: event.clientY };
    });
    gallery.addEventListener('pointerup', function (event) {
      if (!pointerStart) return;
      if (event.target && event.target.closest('button')) {
        pointerStart = null;
        return;
      }
      var x = event.clientX - pointerStart.x;
      var y = event.clientY - pointerStart.y;
      pointerStart = null;
      if (Math.abs(x) < 48 || Math.abs(x) < Math.abs(y)) return;
      select(x < 0 ? current + 1 : current - 1);
    });
    gallery.addEventListener('pointercancel', function () { pointerStart = null; });
    select(current);
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-prof-gallery]')).forEach(bootGallery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);

  if (typeof MutationObserver === 'function' && document.documentElement) {
    if (window.__profGalleryObserver) window.__profGalleryObserver.disconnect();
    window.__profGalleryObserver = new MutationObserver(boot);
    window.__profGalleryObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
